import type { FaireProductEntity } from "../../entity_types/product";

export const p_djxr8f3xer: FaireProductEntity = {
  token: "p_djxr8f3xer",
  type: "product",
  name: "Baseball Stitch Large Tote Bag / Shoulder Bag",
  brandToken: "b_c3xmn96nkh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/7f1a8719b6a80d15a214753a9e963d5c6669e5f475f90e3aff599566c40f51be.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a84e7334c99f15030bcc0d137b3b37ba76dab5db1157e618f839bf54e2866175.jpeg",
    "https://cdn.faire.com/fastly/5da233c126e567fc9ac98704ba216bcf1234145390744d4d7a14509bfe8e614c.jpeg",
    "https://cdn.faire.com/fastly/c751df39be71316216077c1d917d4632e3564b7b2146cec35fee0e641967650c.jpeg",
    "https://cdn.faire.com/fastly/7a5bc136067f1d596577d7e309fdaa6f1a81511a30faa07f34e8b50a4884e945.jpeg",
    "https://cdn.faire.com/fastly/f48ec9bce4260fe23b6d5b24652f6b88f62267ee9fe05fd9e3c7d93d410c47ec.jpeg",
    "https://cdn.faire.com/fastly/4d75957e8a2df70cec8023a4a127868b33f247dc68f5a803c4d0bd6e3a945467.jpeg",
    "https://cdn.faire.com/fastly/50b592ac40e735afd4a95d98c75da3b5103d5f5da0f1c41a9a16545dd0dc97a7.jpeg",
    "https://cdn.faire.com/fastly/a9db7ecbe7de0ff152099ec453dff8c4e20f39386581a355d38e8c48fff4ccad.jpeg",
  ],
  priceDollars: 18.29,
  description:
    'Size : 21" X 15" X 7"\r\nTop Handle Size : 9" L\r\nOne Inside Zipper Pocket\r\nMagnetic Closure\r\nCarry your essentials in style with this spacious baseball stitch tote bag. Designed for sports lovers, it’s perfect for games, travel, or everyday use. Features top handles, bold graphic detail, and ample storage space.\n',
  tags: [],
  msrpDollars: 36.58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:26.859Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
